import { Box, Typography } from '@mui/material'

export default function BulkEditNoMedia() {
  return (
    <Box>
      <Typography variant="h2">To use bulk edit:</Typography>
      <Typography>
        Navigate to <a href="">Search</a>, select items to edit and begin an
        edit.
      </Typography>
    </Box>
  )
}
